






import mixins from 'vue-typed-mixins';
import { PageModeMixin } from '@/main/mixins/pageMode';
import { genVuexComputeds } from '@/main/pages/editFactory';
import { OperationsMixin } from '@/main/mixins/operations';

import { store } from '../../store/edit';

export default mixins(PageModeMixin, OperationsMixin).extend({
	name: 'ZakazkaSlevaMaterialNumberInput',
	props: {
		span: Number,
		storeUri: { type: String, default: null, required: true },
	},

	computed: {
		...genVuexComputeds(store),
		isDisabled(): boolean | null {
			if (this.isViewMode) {
				return true;
			}
			return this.IsBezMarze;
		},
	},
});
